import { Booking, BookingsReadDetailsState } from 'acscp/store';

export function isBookingRead(booking: Booking, bookingsReadDetails: BookingsReadDetailsState): boolean {
    const readDetails = bookingsReadDetails[booking.id];
    if (!readDetails) {
        // Defaulting to "booking is read" in case of unexpected store error/corruption to not annoy the user
        return true;
    }
    return readDetails.read || booking.status === 'Expired' || booking.status === 'Flown' || booking.status === 'Enquiry';
}
